export const createMeter = `
    mutation createMeter($input: CreateMeterInput!) {
        createMeter(input:$input) {
            id
            name
            meterCode
            aggregation
            grain
            unit
            resetPolicy
            purpose
            latenessWindowMinutes
            watermarkDelayMinutes
            status
            dimensions {
                name
                apiKey
            }
            createdByUsername
            createdByUser {
              name
              givenName
              familyName
              email
            }
            created
            updated
    }
}`;

export const updateMeter = `
    mutation updateMeter($input: UpdateMeterInput!) {
        updateMeter(input:$input){
            id
            name
            meterCode
            aggregation
            grain
            unit
            resetPolicy
            purpose
            latenessWindowMinutes
            watermarkDelayMinutes
            status
            dimensions {
                name
                apiKey
            }
            createdByUsername
            createdByUser {
              name
              givenName
              familyName
              email
            }
            created
            updated
        }
}`;

export const deleteMeter = `
    mutation deleteMeter($input: DeleteMeterInput!) {
        deleteMeter(input:$input)
}`;

// FNP-665: narrow status-only activation. Use this (NOT updateMeter) to flip a meter
// DRAFT->ACTIVE. updateMeter has an owner-guard that silently no-ops for catalog
// (deploy-hook-created) meters; activateMeter has no owner guard.
export const activateMeter = `
    mutation activateMeter($id: ID!) {
        activateMeter(id: $id) {
            id
            name
            meterCode
            aggregation
            grain
            unit
            resetPolicy
            purpose
            latenessWindowMinutes
            watermarkDelayMinutes
            status
            dimensions {
                name
                apiKey
            }
            createdByUsername
            createdByUser {
              name
              givenName
              familyName
              email
            }
            created
            updated
        }
}`;

// FNP-748: narrow status-only RETIRE (ACTIVE|DEPRECATED->RETIRED). Like activateMeter,
// use this NOT updateMeter (no owner guard for catalog meters). The billing-api resolver
// fails closed if the meter still has open metering periods (MeterHasOpenPeriods) — the
// service's onError surfaces that message so the admin sees why a retire was blocked.
export const retireMeter = `
    mutation retireMeter($id: ID!) {
        retireMeter(id: $id) {
            id
            name
            meterCode
            aggregation
            grain
            unit
            resetPolicy
            purpose
            latenessWindowMinutes
            watermarkDelayMinutes
            status
            dimensions {
                name
                apiKey
            }
            createdByUsername
            createdByUser {
              name
              givenName
              familyName
              email
            }
            updatedByUsername
            created
            updated
        }
}`;
